import { put } from 'redux-saga/effects';
import * as actions from '../actions/index';
import {instanceaATS as axios} from '../../axios';

export function* trySetJobsSaga(action) {
    try{    
        //const response = yield axios.get('/ats/webservices/atsapplication.php?ws_ats=3&company_id=3&start=1&end=250');
        const response = yield axios.get();
        yield put( actions.sucessSetJobs( response.data ));
    }catch(error){
        yield put( actions.failSetJobs() );
    }
}